import * as _ from "lodash";
import { ActionTypes } from './action-types';
import { IActionCenterToDo, IActionCenterOther, IActionCenterCompliance, IPendingSwap } from '../../models';
import { IActionCenterState } from "../action-center";
import { IPendingSwaps } from "./state";
import { IActionCenterLookupData } from "./actions";
import { IRpChainEndDeclineRatio } from "@nkr/models/center-performance/relative-performance";

// reducer interfaces

interface ISetToDoList {
    type: string,
    todo: IActionCenterToDo
}

interface ISetOtherList {
    type: string,
    other: IActionCenterOther
}

interface ISetComplianceList {
    type: string,
    compliance: IActionCenterCompliance
}

interface ISetPendingSwaps {
    type: string,
    data: IPendingSwaps
}

interface ISetLookupData {
    type: string,
    data: IActionCenterLookupData
}

interface ISetDonorSwaps {
    type: string,
    swaps: IPendingSwap[]
}

interface ISetChainEndDeclineRatio {
    type: string,
    chainEndDeclineRatio: IRpChainEndDeclineRatio
}

// reducer functions

const setToDoList = (state: IActionCenterState, action: ISetToDoList) => {
    state.todo = action.todo;
    return state;
}

const setOtherList = (state: IActionCenterState, action: ISetOtherList) => {
    state.other = action.other;
    return state;
}

const setComplianceList = (state: IActionCenterState, action: ISetComplianceList) => {
    state.compliance = action.compliance;
    return state;
}

const setPendingSwaps = (state: IActionCenterState, action: ISetPendingSwaps) => {
    state.pendingSwaps = action.data;
    return state;
}

const setPastTransplants = (state: IActionCenterState, action: ISetPendingSwaps) => {
    state.pastTransplants = action.data;
    return state;
}

const setLookupData = (state: IActionCenterState, action: ISetLookupData) => {
    state.lookupData = action.data;
    return state;
}

const setDonorSwaps = (state: IActionCenterState, action: ISetDonorSwaps) => {
    state.pendingSwaps.donorSwaps = action.swaps;
    return state;
}

const setChainEndDeclineRatio = (state: IActionCenterState, action: ISetChainEndDeclineRatio) => {
    state.chainEndDeclineRatio = action.chainEndDeclineRatio;
    return state;
}

// reducer creation

var initialState: IActionCenterState = {
    todo: null,
    other: null,
    compliance: null,
    pendingSwaps: {
        recipientSwaps: [],
        internalSwaps: [],
        donorSwaps: [],
        remoteDonorsYourCenter: [],
        remoteDonorsOtherCenter: []
    },
    pastTransplants: {
        recipientSwaps: [],
        internalSwaps: [],
        donorSwaps: [],
        remoteDonorsYourCenter: [],
        remoteDonorsOtherCenter: []
    },
    lookupData: {
        referralDispositions: [],
        coordinatorList: [],
        donorRemoteStatus: []
    }
};

const createReducer = (initialState: IActionCenterState, handlers: any) => {
    return function reducer(state = initialState, action: any) {
        if (handlers.hasOwnProperty(action.type)) {
            let s = _.cloneDeep(state);
            return handlers[action.type](s, action);
        } else {
            return state;
        }
    }
}

const handlers = {
    [ActionTypes.SET_TODO_ITEMS]: setToDoList,
    [ActionTypes.SET_OTHER_ITEMS]: setOtherList,
    [ActionTypes.SET_COMPLIANCE_ITEMS]: setComplianceList,
    [ActionTypes.SET_PENDING_SWAPS]: setPendingSwaps,
    [ActionTypes.SET_PAST_TRANSPLANTS]: setPastTransplants,
    [ActionTypes.SET_LOOKUP_DATA]: setLookupData,
    [ActionTypes.SET_PENDING_SWAPS_DONOR]: setDonorSwaps,
    [ActionTypes.SET_CHAIN_END_DECLINE_RATIO]: setChainEndDeclineRatio
}

export const Reducer = createReducer(initialState, handlers);
